import store from '../store'

export const routes = [
  // staff pages
  {
    path: '/staff',
    meta: {
      requiresAuth: true,
      requiresStaff: true,
    },
    component: () => import('@/views/layout-staff/Index'),
    beforeEnter: (to, from, next) => {
      if (!store.state.authModule.isStaff) {
        next({
          path: '/app',
        })
      } else next()
    },
    children: [
      // Optimap
      {
        name: 'Staff Dashboard',
        path: '',
        component: () => import('@/views/staff/Dashboard'),
      },
      // Customer Account
      {
        name: 'Customer Account',
        path: 'account/:rowkey',
        component: () => import('@/views/staff/account/AccountDetails'),
        props: (route) => ({
          // user: userData,
          ...route.params,
        }),
      },
      // Plat Account Redirect
      {
        name: 'Plat Redirect',
        path: 'plat/:platKey',
        component: () => import('@/views/staff/plat/Redirect'),
        props: (route) => ({
          // user: userData,
          ...route.params,
        }),
      },
      // Optimap
      {
        name: 'Optimap',
        path: 'optimap',
        component: () => import('@/views/staff/OptiMap'),
      },
      // forms
      {
        name: 'Forms',
        path: 'form',
        component: () => import('@/views/staff/form/FormsHome'),
      },
      // formResult
      {
        name: 'Form Results',
        path: 'form-result',
        component: () => import('@/views/staff/formResult/Index'),
      },
      // formResult Details
      {
        name: 'Form Result Details',
        path: 'form-result/details',
        component: () => import('@/views/staff/formResult/FormResultDetails'),
        props: (route) => ({ rowkey: route.query.rowkey }),
      },
      // job/
      {
        name: 'Jobs',
        path: 'jobs',
        component: () => import('@/views/staff/jobs/JobsIndex'),
      },
      // job/batch
      {
        name: 'Job Batch',
        path: 'jobs/batch',
        component: () => import('@/views/staff/jobs/JobBatchDetails'),
        props: (route) => ({ rowkey: route.query.rowkey }),
      },
      // job/details
      {
        name: 'Job Details',
        path: 'jobs/details',
        component: () => import('@/views/staff/jobs/JobDetails'),
        props: (route) => ({ name: route.query.name }),
      },
      // reporting/access-points
      {
        name: 'Access Points',
        path: 'reporting/access-points',
        component: () => import('@/views/staff/reporting/PowAccessPoints'),
      },
      // reporting/new-accounts
      {
        name: 'Activity Logs',
        path: 'reporting/activity-logs',
        component: () => import('@/views/staff/reporting/ActivityLogs'),
      },
      // reporting/new-accounts
      {
        name: 'New Accounts',
        path: 'reporting/new-accounts',
        component: () => import('@/views/staff/reporting/NewAccounts'),
      },
      // reporting/tower-customers
      {
        name: 'Tower Customers',
        path: 'reporting/tower-customers',
        component: () => import('@/views/staff/reporting/TowerCustomers'),
      },
      // reporting/tower-kpis
      {
        name: 'Tower KPIs',
        path: 'reporting/tower-kpis',
        component: () => import('@/views/staff/reporting/TowerKpis'),
      },
      // tools/CheckCoverage
      {
        name: 'Check Coverage',
        path: 'tools/check-coverage',
        component: () => import('@/views/staff/tools/CheckCoverage'),
      },
      // tools/MovePlatServices
      {
        name: 'Move Services',
        path: 'tools/move-plat-services',
        component: () => import('@/views/staff/tools/MovePlatServices'),
      },
      // tools/GenerateLead
      {
        name: 'Generate Lead',
        path: 'tools/generate-lead',
        component: () => import('@/views/staff/tools/GenerateLead'),
      },
      // towers
      {
        name: 'Towers',
        path: 'towers',
        // component: () => import('@/views/staff/tower/TowersHome'),
        component: () => import('@/views/staff/tower/TowersInventory'),
      },
      // towers/infra
      {
        name: 'Towers Infrastructure',
        path: 'towers-infra',
        component: () => import('@/views/staff/tower/TowersInventory'),
      },
      // plans
      {
        name: 'Plans',
        path: 'plans',
        component: () => import('@/views/staff/plan/PlanHome'),
      },
    ],
  },
]
